import { useQuery } from "react-query";
import { getExhibitorsProjects } from "../../services/scientific/exhibitorProject";
import { PagedRequestType } from "../../types/PagedResults";
import { EXHIBITORS_PROJECTS, Key_exhibitorsProjects } from "../../utils/constants";

export const useGetExhibitorsProjectsQuery = (data: PagedRequestType, options:any=null) =>
  useQuery(
    [Key_exhibitorsProjects, JSON.stringify(data)],
    () => getExhibitorsProjects(data),
    options?{...options}:{}
  );
